import axios from 'axios';

import settings from '../libs/config';
import Logger from '../functions/logging';
import ApiError from './apiError.js';

const activityEndpoint = settings.api_host + "/group/activity";
const subscribedEndpoint = settings.api_host + "/group/subscribed";

export const getActivityGroups = async (user_token) => {
	if (!user_token) {
		throw new Error("user_token not provided");
	}

	try {
		const response = await axios.get(activityEndpoint, {
			params: {
				user_token
			}
		});
		Logger.log(this.constructor.name, "getActivityGroups()", response);

		const data = response.data;
		return data.result;
	} catch (error) {
		Logger.error(this.constructor.name, "getActivityGroups()", error);
		throw new ApiError(error);
	}
};

export const getSubscribedGroups = async (user_token) => {
	if (!user_token) {
		throw new Error("user_token not provided");
	}

	try {
		const response = await axios.get(subscribedEndpoint, {
			params: {
				user_token
			}
		});
		Logger.log(this.constructor.name, "getSubscribedGroups()", response);

		const data = response.data;
		return data.result;
	} catch (error) {
		Logger.error(this.constructor.name, "getSubscribedGroups()", error);
		throw new ApiError(error);
	}
};



// WEBPACK FOOTER //
// ./src/api/groups.js